<template>
  <div class="vue timparty-shop-coupons-band shop-coupons-band">
    <div class="iw-actions-bar-container">
      <div class="container p-0">
        <div class="iw-actions-bar"><!----><!---->
          <div>
            <div class="row mb-4 no-gutters">
              <div class="col-md-9 bg-accent">
                <div class="d-flex align-items-center">
                  <div class="bg-accent text-dark p-3">
                    <h5 class="font-weight-bold">
                      {{ pinTitleIntroCopy }}
                    </h5>
                    <p v-html="pinIntroCopyFormatted">
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-3 d-flex align-items-center justify-content-end bg-accent text-primary">
                <div class="w-100">
                  <div class="iw-retrieve-container">
                    <button @click.prevent="getContestShopCoupon" :disabled="btnDisabled" class="btn btn-primary btn-lg btn-block cta-generic">
                      Richiedi pin
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <basic-modal :modal-id="modal_id" modal-class="modal-md" class="modal-acceptance" :show="modal.show" v-on:modalClose="modal.show = false">
      <div class="modal-body text-center p-4">
        <div>
          <img class="mx-auto d-block" :src="modulePath('/js/src/assets/images/icon-shop.png')">
          <h4 class="pb-1">{{ assignedPinCode }}</h4>
          <p v-html="pinPopupSuccessBodyFormatted">
          </p>
        </div>
        <a href="/pin-attivi" class="btn btn-primary btn-md pin-attivi-link">vai al riepilogo pin</a>
      </div>
    </basic-modal>
    <ErrorModal :error="error" v-on:modalClose="error = null"/>
  </div>
</template>

<script>

/* eslint-disable */

import TimPartyMixin from '../mixins/TimPartyMixin';
import BasicModal from "./BasicModal";
import {mapState} from "vuex";
import ErrorModal from './ErrorModal.vue'

export default {
  name: 'ShopCouponsBand',
  mixins: [ TimPartyMixin ],
  components: { BasicModal, ErrorModal },
  props: {
    contestId: Number,
    shopCouponsType: String,
    pinIntroCopy: String,
    pinTitleIntroCopy: String,
    pinPopupSuccessBody: String,
    pinCanBeRequested: Boolean,
    hasPin: Boolean,
    apiUrl: {
      type: String,
      default: '/api/contest/handleAction',
    }

  },
  data: function() {

    return {
      email: '',
      assignedPinCode: '',
      btnDisabled: false,
      modal: {
        id: 'modal-shop-coupons',
        show: false,
        class_name: 'modal-sm',
        error: null,
        state: null,
      },
      errors: {
        '404': 'C\'è stato un errore durante la procedura di assegnazione PIN',
        '409': 'Hai già un pin assegnato per questo contest',
        '500': 'C\'è stato un errore durante la procedura di assegnazione PIN',
        '400': 'Hai superato il tempo massimo per richiedere il PIN per questo concorso'
      }
    };
  },
  mounted: function() {
    this.setApiUrl(this.apiUrl);

    if (!this.pinCanBeRequested || this.hasPin) {
      this.btnDisabled = true;
    }
  },

  methods: {
    getContestShopCoupon: function() {
      var payload = {
        action: 'getContestShopCoupon',
        access_token: this.access_token,
        contestId: this.contestId,
      };
      let self = this;

      this.callApi(payload, function(response){
        self.loading = false;

        if (response.assignedPinCode) {
          self.assignedPinCode = response.assignedPinCode;
          self.modal.show = true;
          self.btnDisabled = true;
        } else if (!response.success) {
          self.showError(null, self.errors[response.data.errorCode]);
        }
      });
    }
  },
  computed: {
    ...mapState([

    ]),
    pinIntroCopyFormatted () {
      return '<div class="text-primary">' + this.pinIntroCopy + '</div>';
    },
    pinPopupSuccessBodyFormatted () {
      return '<div>' + this.pinPopupSuccessBody + '</div>';
    }
  }
}
</script>
